import { MEASUREMENT_SYSTEM } from 'models/measurementSystem';

export const convertToCurrentSystem = (value, measurementSystem) =>
  value == null ? null : measurementSystem === MEASUREMENT_SYSTEM.imperial ? value : Math.round(value * 0.092903);

export const convertToStandardSystem = (value, measurementSystem) =>
  value == null ? null : measurementSystem === MEASUREMENT_SYSTEM.imperial ? value : Math.round(value * 10.763915);
